import { Notepad, UsersFour } from '@phosphor-icons/react'
import React, { useContext, useEffect, useState } from 'react'
import { ActionCard } from '../../components/ActionCard'

import { SideTab } from '../../components/SideTab'
import { DefaultContent } from '../../components/common/DefaultContent'
import { EditUser } from './components/EditUser'
import { EmployeesTable } from './components/EmployeesTable'
import { NewUser } from './components/NewUser'
import { Body, Container, Header, Title } from './styled'
import api from '../../services/api'
import { Context } from '../../context/context_employee'
import { socket } from '../../services/socketApi'
import { useSocket } from '../../context/socketProvider'

import { Helmet } from 'react-helmet'

interface EmployessDataProps {
  id?: string
  login: string
  password: string
  role: string
  avatar?: string
  UserInfo: {
    name: string
    email: string
    phone: string
    birthdate: string
  }[]
  Employee: {
    id_base: string
  }
  Address: {
    address: string
    zipcode: string
    burgh: string
    city: string
    state: string
    latitude: number
    longitude: number
  }[]
  outpost: string[]
  user_access?: { id: string; value: string }[]
}

export const Employees = () => {
  const [newUserState, setNewUserState] = useState<boolean>(false)

  const { employees } = useContext(Context)
  const [data, setData] = useState<EmployessDataProps>()

  const [openEdit, setOpenEdit] = useState(false)

  const handleEditModal = async (id) => {
    try {
      const response = await api.post('/v1/dashboard/employees/find', { id })
      setData(response.data)
      setOpenEdit((prev) => !prev)
    } catch (err) {
      console.log(err)
    }
  }

  function handlerState(state) {
    state((prev) => !prev)
  }

  return (
    <>
      <Helmet>
        <title>Previx- Funcionários</title>
        <meta name="Previx - Funcionários" content="Página de funcionários" />
      </Helmet>
      <DefaultContent
        icon={<UsersFour size={26} color="#003E5F" weight="fill" />}
        title="Previx - Funcionários"
      >
        <Container>
          <Header>
            <ActionCard.Root>
              <ActionCard.Content
                onclick={() => handlerState(setNewUserState)}
                background="#52427B"
                border="#BBA7E3"
                color="#fff"
              >
                <ActionCard.Icon
                  transform={20}
                  icon={<Notepad size={60} weight="fill" color="#BBA7E3" />}
                />

                <ActionCard.Information value="Cadastrar novo usuário" />
              </ActionCard.Content>
            </ActionCard.Root>
          </Header>
          <Body>
            <Title>Lista de usuários cadastrados na plataforma</Title>
            <EmployeesTable onclick={handleEditModal} data={employees} />
          </Body>
        </Container>
      </DefaultContent>

      {/* Sidetab New user */}
      <SideTab
        open={newUserState}
        title="Cadastro de novo usuário"
        toggleFunction={() => handlerState(setNewUserState)}
        width="50%"
      >
        <NewUser data={employees} />
      </SideTab>
      {/* Sidetab  New user */}

      {/* Sidetab Edit User */}
      <SideTab
        open={openEdit}
        title="Detalhado de um usuário"
        toggleFunction={() => setOpenEdit((prev) => !prev)}
      >
        <EditUser data={data} />
      </SideTab>
      {/* Sidetab Edit User  */}
    </>
  )
}
